import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wikipedia-w': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M640 51.2l-0.3 12.2c-28.1 0.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6h-13.6l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-0.3 0.3-15 0-15-0.3-46.9-109.7-96.1-218.6-143.1-328.6-11.4-26.7-49.4-70-75.6-69.7 0-3.1-0.3-10-0.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7v-13.9l142.5 0.3v13.1c-19.4 0.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4 0.3-3.6 0-10.3 0.3-13.6 44.4-0.3 111.1-0.3 123.1-0.6v13.6c-22.5 0.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7l122.4-282.6c-8.6-23.1-36.4-28.1-47.2-28.3v-13.9l127.8 1.1z'
      }
    ]
  }
})
